import { NormalizedNumber } from '@sparkdotfi/common-universal'

import { AccountSparkRewardsSummary, InterestData } from '../types'
import { makeSavingsOverview, SavingsOverview, STEP_IN_MS } from './makeSavingsOverview'
import { calculateOneYearProjection } from './projections'
import { Token } from '@/domain/types/Token'
import { SavingsConverter } from '@/features/savings/logic/savings-converters/types'

export interface GetInterestDataParams {
  savingsConverter: SavingsConverter
  savingsTokenBalance: NormalizedNumber
  underlyingToken: Token
  sparkRewardsSummary: AccountSparkRewardsSummary
  timestamp: number
}

export type MakeSavingsTokenDetailsResult = InterestData | undefined

export function getInterestData({
  savingsConverter,
  savingsTokenBalance,
  underlyingToken,
  sparkRewardsSummary,
  timestamp,
}: GetInterestDataParams): InterestData {
  const oneYearProjection = calculateOneYearProjection({
    timestamp,
    shares: savingsTokenBalance,
    savingsConverter,
  })

  const balanceRefreshIntervalInMs = savingsConverter.supportsRealTimeInterestAccrual ? STEP_IN_MS : undefined
  const calculateUnderlyingTokenBalance = calculateSavingsBalanceFactory(savingsConverter, savingsTokenBalance)

  const { depositedAssets: currentUnderlyingTokenBalance } = calculateUnderlyingTokenBalance(timestamp * 1000)
  const sparkRewardsOneYearProjection = underlyingToken
    .toUSD(currentUnderlyingTokenBalance)
    .times(sparkRewardsSummary.totalApy)

  return {
    APY: savingsConverter.apy,
    oneYearProjection,
    sparkRewardsOneYearProjection,
    calculateUnderlyingTokenBalance,
    balanceRefreshIntervalInMs,
  }
}

function calculateSavingsBalanceFactory(savingsConverter: SavingsConverter, savingsTokenBalance: NormalizedNumber) {
  return function calculateSavingsBalance(timestampInMs: number): SavingsOverview {
    return makeSavingsOverview({
      savingsTokenBalance,
      savingsConverter,
      timestampInMs,
    })
  }
}
